import { render } from "./Sperrung.pug?vue&type=template&id=06730d30&lang=pug"
import script from "./Sperrung.js?vue&type=script&lang=js"
export * from "./Sperrung.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__